import { render, staticRenderFns } from "./PreviewReport5.vue?vue&type=template&id=2efafcf5&scoped=true"
import script from "./PreviewReport5.vue?vue&type=script&lang=js"
export * from "./PreviewReport5.vue?vue&type=script&lang=js"
import style0 from "./PreviewReport5.vue?vue&type=style&index=0&id=2efafcf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efafcf5",
  null
  
)

export default component.exports